<template lang="pug">
  v-layout.wf-justify-content-center(row wrap)
    v-flex(xs12)
      Navbar(:noBackChevron="true")

    template(v-if="showFan")
      v-flex(xs12 lg4 mx-2)
        fan-loader(
          :loading="showFan"
        )
          div(slot="loadingMsg"
            class="full-width text-xs-center headline my-2") Please stay on this page while we process your request...
    v-flex(v-if="showStatusButton" xs12)
      v-card#pendingStatusMsg(
        flat
      )
        v-card-text Your application is still pending approval. Results usually take no longer than an hour. If your approval status is still pending after 24 hours, please contact GreenSky's Customer Service at <a href="tel:1-866-936-0602">866-936-0602</a> for further information.
      v-btn(
        id="status-button"
        @click="cycleGetStatus"
      ) Get Status

    ApplicationStatusGreenskyFlow(
      v-if="lender === 'greensky'"
      :showFan="showFan"
      @showFan="startShowingFan()"
      @returnHome="returnHome()"
    )

    ApplicationStatusFortivaFlow(
      v-if="lender === 'fortiva'"
      :showFan="showFan"
      @returnHome="returnHome()"
    )

</template>

<script>
  import Navbar from 'Components/Navbar.vue'
  import ApplicationStatusGreenskyFlow from 'Components/ApplicationStatusGreensky.vue'
  import ApplicationStatusFortivaFlow from 'Components/ApplicationStatusFortiva.vue'
  import StatusModal from 'Components/StatusModal.vue'
  import FanLoader from 'Components/FanLoader.vue'
  import { mapState, mapActions, mapGetters } from 'vuex'

  export default {
    name: 'ApplicationStatus',
    components: {
      ApplicationStatusGreenskyFlow,
      ApplicationStatusFortivaFlow,
      FanLoader,
      StatusModal,
      Navbar,
    },
    data () {
      return {
        mounted: false,
        showFan: true
      }
    },
    computed: {
      ...mapState({
        statusLoopComplete: state => state.loanApplication.statusLoopComplete,
        applicationStatus: state => state.loanApplication.applicationStatus,
        paceEligibility: state => state.loanApplication.paceEligibility,
        easyLinkUser: state => state.easyLink.active,
      }),
      ...mapGetters([
        'selectedOffer'
      ]),
      lender () {
        return this.$store.state.loanApplication.lender.id
      },
      statusPending () {
        return this.applicationStatus === 'pending'
      },
      showStatusButton () {
        return this.statusPending &&
          this.statusLoopComplete &&
          !this.showFan
      }
    },
    methods: {
      ...mapActions([
        'cycleGetStatus',
        'getOffers',
        'loanApplicationClear'
      ]),
      returnHome () {
        this.loanApplicationClear()
        if (this.easyLinkUser) {
          this.$router.push({
            path: '/credit-application/application-done'
          })
        } else {
          this.$router.push({
            path: '/home'
          })
        }
      },
      startShowingFan () {
        this.showFan = true
      },
      stopShowingFan () {
        this.showFan = false
      },
    },
    watch: {
      applicationStatus () {
        switch (this.applicationStatus) {
          case 'received':
            this.stopShowingFan()
            break
          case 'offer_available':
            this.getOffers()
            break
          case 'under_review':
            this.stopShowingFan()
            break
          case 'declined':
            this.stopShowingFan()
            break
          case 'rejected':
            this.stopShowingFan()
            break
          case 'recalculated':
            this.$router.push({
              path: '/credit-application/application-results'
            })
            break
          case 'approved':
            this.$router.push({
              path: '/credit-application/application-results'
            })
            break
        }
      },
      selectedOffer () {
        this.$router.push({
          path: '/credit-application/application-results'
        })
      },
      statusLoopComplete () {
        if (this.statusLoopComplete) {
          if (this.applicationStatus !== 'offer_available') {
            this.stopShowingFan()
          }
        } else {
          this.startShowingFan()
        }
      }
    },
    mounted () {
      if (this.applicationStatus === 'under_review' ||
        this.applicationStatus === 'declined' ||
        this.applicationStatus === 'rejected') {
        this.stopShowingFan()
      }
    }
  }
</script>

<style>
#pendingStatusMsg {
    width: 60%;
    margin: auto;
    padding: 10px
  }
</style>
